import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import DefRoutes from "../routes/routes.json";
import t from "../i18n/i18n";
import { ChangeTheme } from "../store/reducers/theme.reducer";
import { useCallback } from "react";

function useInitPage({ title, theme, admin }) {
  const dispatch = useDispatch();
  const { logged } = useSelector((store) => store.auth);
  const { pathname } = useLocation();
  const { token } = useParams();

  if (
    !logged &&
    ![
      DefRoutes.SignIn,
      DefRoutes.SignUp,
      DefRoutes.RecoveryPassword,
      DefRoutes.CreateNewPassword.replace(":token", token),
      DefRoutes.TFA,
    ].includes(pathname)
  ) {
    sessionStorage.setItem("@lastPageTriedToAcess", pathname);
    window.location = DefRoutes.SignIn;
  }

  if (theme) dispatch(ChangeTheme(theme));
  if (!theme) dispatch(ChangeTheme({ background: "login-bg" }));

  document.title = `${t("Config.AppName")} - ${title}`;

  const generageScriptToOpenAndCloseMobileMenus = useCallback(
    (script) => {
      script.innerHTML = `
        var elementClicked = document.querySelector(".toggle-btn");
        var elementYouWantToShow = document.querySelector(".sm-toggle-warp");
        
        var elementClose = document.querySelector(".toggle-close-btn");
        elementClicked.addEventListener("click", ()=>{
          elementYouWantToShow.classList.add("is-active");
        
        });
        
        elementClose.addEventListener("click", ()=>{
          elementYouWantToShow.classList.remove("is-active");
        
        });
        
        var el = document.querySelector('.side-toggle');
        var elside = document.querySelector('.sidebar-main');
        if(el && elside){
          el.onclick = function() {
            el.classList.toggle('active');
            elside.classList.toggle('is-active');
          }
        }else{
          var el = document.querySelector('.side-toggle');
          var elclose = document.querySelector('.side-toggle-close');
          var elsidebar = document.querySelector('.loyal-sideinner-main');
          if(el && elclose && elsidebar){
            el.onclick = function() {
              el.classList.toggle('active');
              elsidebar.classList.add('is-active');
            } 
    
            elclose.onclick = function() {
              el.classList.remove('active');
              elsidebar.classList.remove('is-active');
            }
          }
        }
    `;

      if (admin) {
        script.innerHTML += `
      var allPanels = document.querySelectorAll('.admin-list .panel');
      var squeezebox2 = new Squeezebox({      
        wrapperEl : '.admin-list',
        headersClass : 'tab',
        foldersClass : '.admin-list .panel',
        closeOthers : false,
        speed : '.5s'
      });
      
      squeezebox2.init();
      `;
      }
      script.async = true;

      document.body.appendChild(script);
    },
    [admin],
  );

  useEffect(() => {
    const script = document.createElement("script");
    // const vanilla = document.createElement("script");

    generageScriptToOpenAndCloseMobileMenus(script);

    // handleLangChange();

    // vanilla.src = "/js/vanilla-function.js";

    // document.body.appendChild(vanilla);

    return () => {
      // document.body.removeChild(vanilla);
      document.body.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useInitPage;
